export default function Footer() {
  return (
    <footer className="h-14 md:h-16 flex items-center">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-center text-sm text-gray-500">
        <span>© 2026 GiveAura</span>
        <span className="mx-2">•</span>
        <button className="hover:underline hover:text-gray-700 transition-colors">
          Privacy Policy
        </button>
      </div>
    </footer>
  );
}
